<div class="dashboard-container">

  <!-- PROFILE HEADER: Welcome & Completeness -->
  <div class="row mb-4">
    <div class="col-12">
      <mat-card class="profile-header-card mat-elevation-z2">
        <div class="d-flex align-items-center p-3">
          <div class="avatar-circle mr-3">
            {{ (custProfile.firstName?.charAt(0) || '') + (custProfile.lastName?.charAt(0) || '') }}
          </div>
          <div class="flex-grow-1">
            <h2 class="m-0">Welcome, {{ custProfile.firstName || 'User' }}!</h2>
            <p class="text-muted m-0">{{ custProfile.loginId }}</p>
          </div>
          <div class="action-buttons">
            <button mat-raised-button color="primary" (click)="changePassword()">
              <mat-icon>lock</mat-icon> Change Password
            </button>
          </div>
        </div>
        <mat-progress-bar mode="determinate" value="40" class="profile-progress"></mat-progress-bar>
        <div class="p-2 text-right text-muted small">Profile Completeness: 40%</div>
      </mat-card>
    </div>
  </div>

  <!-- MY COURSE SUBSCRIPTIONS SECTION -->
  <div class="row mb-4">
    <div class="col-12">
      <mat-card class="dashboard-card mat-elevation-z2 subscriptions-section-card">
        <mat-card-header class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <mat-icon class="section-header-icon mr-2 text-primary">card_membership</mat-icon>
            <mat-card-title class="m-0 font-weight-bold">My Course Subscriptions</mat-card-title>
          </div>
          <span class="sub-count-pill" *ngIf="userSubscriptions.length > 0">
            {{ userSubscriptions.length }} Subscription{{ userSubscriptions.length > 1 ? 's' : '' }}
          </span>
        </mat-card-header>

        <mat-card-content class="pt-3">
          <!-- Loading State -->
          <div *ngIf="isLoadingSubscriptions" class="text-center py-4">
            <mat-spinner diameter="36" class="mx-auto mb-2"></mat-spinner>
            <p class="text-muted">Loading your subscriptions...</p>
          </div>

          <!-- Empty State -->
          <div *ngIf="!isLoadingSubscriptions && userSubscriptions.length === 0" class="empty-subs-box text-center py-4">
            <div class="empty-icon-circle mx-auto mb-3">
              <mat-icon>school</mat-icon>
            </div>
            <h4 class="font-weight-bold mb-1">No Course Subscriptions Yet</h4>
            <p class="text-muted mb-3">Explore our interactive textbooks and subscribe to unlock full chapter lessons, audio narrations, and quizzes.</p>
            <button mat-flat-button color="primary" routerLink="/courses">
              <mat-icon>explore</mat-icon> Browse Course Catalog
            </button>
          </div>

          <!-- Subscriptions Grid -->
          <div *ngIf="!isLoadingSubscriptions && userSubscriptions.length > 0" class="subscriptions-grid">
            <div *ngFor="let sub of userSubscriptions" class="sub-item-card" [class.sub-card-active]="isSubscriptionActive(sub)" [class.sub-card-expired]="!isSubscriptionActive(sub)">
              
              <!-- Card Header / Title Row -->
              <div class="sub-item-header">
                <div class="sub-course-info">
                  <div class="sub-icon-avatar" [class.active-avatar]="isSubscriptionActive(sub)" [class.expired-avatar]="!isSubscriptionActive(sub)">
                    <mat-icon>{{ getCourseIcon(sub) }}</mat-icon>
                  </div>
                  <div>
                    <h3 class="sub-course-title">{{ getCourseTitle(sub) }}</h3>
                    <span class="sub-plan-tag">{{ (sub.planType || 'ANNUAL') | titlecase }} Plan</span>
                  </div>
                </div>

                <!-- Status Badge -->
                <div>
                  <span class="status-badge status-active" *ngIf="isSubscriptionActive(sub)">
                    <mat-icon>verified</mat-icon> Active
                  </span>
                  <span class="status-badge status-expired" *ngIf="!isSubscriptionActive(sub)">
                    <mat-icon>error_outline</mat-icon> Expired
                  </span>
                </div>
              </div>

              <!-- Card Details -->
              <div class="sub-item-details">
                <div class="detail-row" *ngIf="sub.amountPaid">
                  <span class="detail-label">Amount:</span>
                  <span class="detail-val font-weight-bold">${{ sub.amountPaid }} {{ sub.currency || 'USD' }}</span>
                </div>
                <div class="detail-row" *ngIf="sub.createdAt">
                  <span class="detail-label">Subscribed on:</span>
                  <span class="detail-val">{{ sub.createdAt | date:'mediumDate' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">{{ isSubscriptionActive(sub) ? 'Renews / Valid until:' : 'Expired on:' }}</span>
                  <span class="detail-val font-weight-bold" [class.text-danger]="!isSubscriptionActive(sub)" [class.text-success]="isSubscriptionActive(sub)">
                    {{ sub.currentPeriodEnd ? (sub.currentPeriodEnd | date:'mediumDate') : 'Active' }}
                  </span>
                </div>
              </div>

              <!-- Card Actions -->
              <div class="sub-item-actions">
                <button
                  *ngIf="isSubscriptionActive(sub)"
                  mat-flat-button
                  class="action-btn access-btn"
                  (click)="openCourse(sub)">
                  <mat-icon>play_circle</mat-icon> Access Course &rarr;
                </button>

                <button
                  *ngIf="!isSubscriptionActive(sub)"
                  mat-flat-button
                  class="action-btn renew-btn"
                  (click)="renewSubscription(sub)">
                  <mat-icon>autorenew</mat-icon> Renew Subscription
                </button>
              </div>

            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- CONTENT GRID -->
  <div class="row">

    <!-- LEFT COL: Personal & Contact -->
    <div class="col-md-5 mb-4">
      <!-- PERSONAL DETAILS CARD -->
      <mat-card class="dashboard-card mb-4 mat-elevation-z2">
        <mat-card-header>
          <mat-card-title>Personal Details</mat-card-title>
        </mat-card-header>
        <mat-card-content class="pt-3">
          <form>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>First Name</mat-label>
              <input matInput [(ngModel)]="custProfile.firstName" name="firstName" [readonly]="true">
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Last Name</mat-label>
              <input matInput [(ngModel)]="custProfile.lastName" name="lastName" [readonly]="true">
            </mat-form-field>
          </form>
        </mat-card-content>
      </mat-card>

      <!-- CONTACT INFO CARD -->
      <mat-card class="dashboard-card mat-elevation-z2">
        <mat-card-header>
          <mat-card-title>Contact Information</mat-card-title>
        </mat-card-header>
        <mat-card-content class="pt-3">
          <form>
            <div class="d-flex">
              <mat-form-field appearance="outline" class="mr-2" style="width: 120px;">
                <mat-label>Code</mat-label>
                <mat-select [(value)]="custProfile.primaryPhoneCountryCode">
                  <mat-option *ngFor="let code of countryPhoneCodes" [value]="code.phonecode">
                    +{{ code.phonecode }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="flex-grow-1">
                <mat-label>Primary Phone</mat-label>
                <input matInput [(ngModel)]="custProfile.primaryPhone" name="primaryPhone" appPhoneMask>
                <mat-icon matSuffix>phone</mat-icon>
              </mat-form-field>
            </div>

            <button mat-stroked-button color="primary" class="w-100" (click)="saveCustomerPhones()">
              Save Contact Info
            </button>
          </form>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- RIGHT COL: Addresses -->
    <div class="col-md-7 mb-4">

      <!-- HOME ADDRESS -->
      <mat-card class="dashboard-card mb-4 mat-elevation-z2">
        <mat-card-header class="d-flex justify-content-between align-items-center">
          <mat-card-title>Home / Office Address</mat-card-title>
          <mat-icon class="text-muted">home</mat-icon>
        </mat-card-header>
        <mat-card-content class="pt-3">
          <app-address #address1 [addressInput]="custProfile.homeOrOfficeAddress"
            (addressChangeEvent)="homeOrOfficeAddressChangedEvent($event)"></app-address>
        </mat-card-content>
        <mat-card-actions align="end">
          <button mat-raised-button color="primary" (click)="address1.submitAddress()">Update Address</button>
        </mat-card-actions>
      </mat-card>

      <!-- SHIPPING ADDRESS -->
      <mat-card class="dashboard-card mat-elevation-z2">
        <mat-card-header class="d-flex justify-content-between align-items-center">
          <mat-card-title>Shipping Address</mat-card-title>
          <mat-icon class="text-muted">local_shipping</mat-icon>
        </mat-card-header>
        <mat-card-content class="pt-3">
          <div class="mb-3">
            <button mat-button color="accent" (click)="copyHomeOrOfficeAddress()">
              <mat-icon>content_copy</mat-icon> Same as Home Address
            </button>
          </div>
          <app-address #address2 [addressInput]="custProfile.mailingOrShippingAddress"
            (addressChangeEvent)="mailingAddressChangedEvent($event)">
          </app-address>
        </mat-card-content>
        <mat-card-actions align="end">
          <button mat-raised-button color="primary" (click)="address2.submitAddress()">Update Address</button>
        </mat-card-actions>
      </mat-card>

    </div>
  </div>
</div>